export default {
	squareSlider: ['loader--square-slider'],
	squareExploder: ['loader--square-exploder'],
	dots: ['loader--dots'],
	circle: ['loader--circle']
};
